import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EstoqueService } from 'src/app/service/estoque.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { Estoque } from './estoque';
import { ProductService } from 'src/app/service/product.service';
import { FornecedorService } from 'src/app/service/fornecedor.service';

@Component({
  selector: 'app-estoque',
  templateUrl: './estoque.component.html',
  styleUrls: ['./estoque.component.scss']
})
export class EstoqueComponent implements OnInit {


  formulario: FormGroup;
  listEstoque: Estoque[] = []; 
  ordemColunasTabela = ['id','createdAt', 'fornecedor','produto','qdtProduct', 'amountPaid'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100]; // [10,20,30] quantidade de item por página
  mensagemErros: String[] = []; //array de strings dos erros retornados do backend
  nameProduct: string;
  nameFornecedor: string;
  
  constructor(
    private estoqueService: EstoqueService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private productService: ProductService,
    private fornecedorService: FornecedorService
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    this.listarEstoque(this.pagina, this.tamanho);
  }

  limparFormulario() {
    this.formulario.reset();
    this.nameProduct = "";
    this.nameFornecedor = "";
  }

  listarEstoque(pagina: number, tamanho: number) {// definir a primeira página e o tamanho inicial
    this.estoqueService.list(pagina, tamanho).subscribe((response) => {
      this.listEstoque = response.content; // pegar o conteudo do pag
      this.totalElementos = response.totalElements;// pegar o total de elementos
      this.pagina = response.number;// pegar o numero de paginas
    });
  }

  submit() {
    //pegar os dados do formulário
    const formValues = this.formulario.value;
    // cria e adiciona no objeto
    const estoque: Estoque = new Estoque(
      formValues.id,
      formValues.product,
      formValues.supplier,
      formValues.qdtProduct,
      formValues.amountPaid,
      formValues.invoiceNumber,
      formValues.obser,
      formValues.fornecedor,
      formValues.produto,
      formValues.createdAt);

    if (formValues.id) {
      this.estoqueService.update(estoque).subscribe(resposta => {
        this.listarEstoque(this.pagina, this.tamanho);
        // exibir mensagem snackbar
        this.snackBar.open('Entrada alterado com sucesso!', 'Sucesso', {
          duration: 2000
        })
        //limpar formulário
        this.formulario.reset();
        this.nameProduct = "";
        this.nameFornecedor = "";
      }, errorResponse => {
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        })
      })
    } else {
      // cria e adiciona no objeto
      this.estoqueService.save(estoque).subscribe(resposta => {
        this.listarEstoque(this.pagina, this.tamanho);
        // exibir mensagem snackbar
        this.snackBar.open('Entrada salvo com sucesso!', 'Sucesso', {
          duration: 2000
        })
        //limpar formulário
        this.formulario.reset();
        this.nameProduct = "";
        this.nameFornecedor = "";
      }, errorResponse => {
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        })
      })
    }
  }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      product: [null, Validators.nullValidator],
      supplier: [null, Validators.nullValidator],
      qdtProduct: [null, Validators.nullValidator],
      amountPaid: [null, Validators.nullValidator],
      invoiceNumber: [null],
      obser: [null]   
    })
  }

  paginar(event: PageEvent) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.listarEstoque(this.pagina, this.tamanho);
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      // se clicar em ok chama evento de excluir
      if (result) {
        this.excluir(id);
      }
    });
  }

  private excluir(id: number) {
    this.estoqueService.delete(id).subscribe((response) => {
      this.ngOnInit();
      this.mensagemErros = [];
      // exibir mensagem snackbar
      this.snackBar.open('Entrada excluido com sucesso!', 'Sucesso', {
        duration: 2000
      })
    }, errorResponse => {
      // exibe mensagem de erro da api
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    })
  }

  editar(id: number) {
    this.estoqueService.findClientById(id).subscribe((response) => {
      // cria e adiciona no objeto
      this.formulario.controls.id.setValue(id);
      this.formulario.controls.product.setValue(response.product);
      this.formulario.controls.supplier.setValue(response.supplier);
      this.formulario.controls.qdtProduct.setValue(response.qdtProduct);
      this.formulario.controls.amountPaid.setValue(response.amountPaid);
      this.formulario.controls.invoiceNumber.setValue(response.invoiceNumber);
      this.formulario.controls.obser.setValue(response.obser);
      this.formulario.controls.fornecedor.setValue(response.fornecedor);
      this.formulario.controls.produto.setValue(response.produto);
      this.formulario.controls.createdAt.setValue(response.createdAt);
    })
  }

  buscarProduto() {
    const formValues = this.formulario.value;
    this.productService.findProductByIdActive(formValues.product).subscribe((response) => {
      this.nameProduct = response.name;         
    }, errorResponse => {
      this.snackBar.open(errorResponse.error.message, 'ERRO', {
        duration: 3000
      })
    })
  }

  buscarFornecedor() {
    const formValues = this.formulario.value;
    this.fornecedorService.findFornecedorById(formValues.supplier).subscribe((response) => {
      this.nameFornecedor = response.razaoSocial;         
    }, errorResponse => {
      this.snackBar.open(errorResponse.error.message, 'ERRO', {
        duration: 3000
      })
    })
  }

}
